import { useInstance } from "@meraki-internal/react-dependency-injection";
import { Volunteer } from "./Volunteer"
import { AutoStoppingCarousel } from "./support/AutoStoppingCarousel";
import { DataModelV2 } from "./data";
import { useSubscription } from "@meraki-internal/state";

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
    }
};



export const OurVolunteers: React.FC = () => {
    const data = useInstance(DataModelV2);
    useSubscription(() => data);

    return (
        <section className="section-content-block" id="volunteers" style={{ scrollMarginTop: '5.2rem' }}>
            <div className="container">
                <div className="row section-heading-wrapper">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-left">
                        <h2>Our <span>Volunteers</span></h2>
                        <h4>Competitive Robotics in the Black Hills wouldn't be possible without our coaches and volunteers.</h4>
                    </div>
                </div>

                <div className="row wow fadeIn" id="volunteer-list">
                    <AutoStoppingCarousel responsive={responsive}
                        autoPlaySpeed={1500}
                        infinite
                    >
                        {data.getShuffledVolunteers().map(volunteer => (
                            <Volunteer key={volunteer.imagePath} volunteer={volunteer} />
                        ))}

                    </AutoStoppingCarousel>

                </div>
            </div>
        </section>
    )
}